import useCustomerAction from './useCustomerAction';
import { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoriteContext';
import { productApi } from '../services/productApi';
import { getImageUrls } from '../utils/image';
import { normalizeProduct, getRetailPrice } from '../services/productService';

export function useProductCard(product) {
  const { dispatch: cartDispatch } = useCart();
  const authorize = useCustomerAction();
  const [notice, setNotice] = useState('');
  const { isFavorite, dispatch: favDispatch } = useFavorites();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [bundleItems, setBundleItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [loadingVariants, setLoadingVariants] = useState(false);

  const normalized = normalizeProduct(product);
  const groupId = normalized.groupId;

  useEffect(() => {
    if (groupId) {
      productApi.getGroup(groupId)
        .then(res => {
          const list = Array.isArray(res) ? res : res.products || [];
          setBundleItems(list.filter(p => p.id !== product.id));
        })
        .catch(() => setBundleItems([]));
    } else {
      setBundleItems([]);
    }
  }, [groupId, product.id]);

  const images = getImageUrls(normalized);
  const fullUrls = images.length ? images : [null];

  const retailPrice = getRetailPrice(normalized);

  const addToCart = (e) => { e.stopPropagation(); e.preventDefault(); authorize({ type: 'choose-size', productId: product.id }, openSizeModal); };

  const openSizeModal = async () => {
    setModalOpen(true);
    setLoadingVariants(true);
    try {
      const data = await productApi.getById(product.id);
      const normalizedData = normalizeProduct(data);
      if (normalizedData.variants && normalizedData.variants.length > 0) {
        setVariants(normalizedData.variants);
        const available = normalizedData.variants.find(v => v.stock > 0 && getRetailPrice(normalizedData, v) > 0);
        if (available) setSelectedVariant(available);
      } else { setNotice('Товар сейчас недоступен для заказа'); }
    } catch { setNotice('Не удалось загрузить размеры. Повторите попытку.'); } finally { setLoadingVariants(false); }
  };

  const closeModal = () => { setModalOpen(false); setSelectedVariant(null); setVariants([]); };

  const handleModalAdd = () => {
    if (!selectedVariant || selectedVariant.stock <= 0 || getRetailPrice(normalized, selectedVariant) <= 0) return;
    authorize({ type: 'cart', productId: product.id, variantId: selectedVariant.id }, () => {
      cartDispatch({ type: 'ADD_TO_CART', payload: { ...product, selectedVariantId: selectedVariant.id, selectedSize: selectedVariant.size, price: getRetailPrice(normalized, selectedVariant), stock: selectedVariant.stock } });
      closeModal(); setNotice('Добавлено в корзину');
    });
  };
  const toggleFavorite = e => { e.stopPropagation(); e.preventDefault(); authorize({ type: 'favorite', productId: product.id }, () => favDispatch({ type: 'TOGGLE_FAVORITE', payload: product })); };

  const favorite = isFavorite(product.id);
  const oldPrice = normalized.oldPrice;
  const discountPercent = normalized.discountPercent ?? 0;

  return {
    notice: authorize.error || notice,
    currentIndex, setCurrentIndex,
    bundleItems, fullUrls,
    modalOpen, variants, selectedVariant, setSelectedVariant, loadingVariants,
    addToCart, closeModal, handleModalAdd,
    toggleFavorite, favorite,
    displayPrice: retailPrice, oldPrice, discountPercent,
  };
}
